// SPDX-FileCopyrightText: 2026 Povl Filip Sonne-Frederiksen
//
// SPDX-License-Identifier: GPL-3.0-or-later

import type { ResourceView } from '../../../api/types';
import { ROW_THUMB_MAX_SIZE } from '../../../kortlaegning/photo';
import { ViewImage } from '../../kortlaegning/ViewImage';
import styles from './Tabel.module.css';

/** Fetch cap for a row thumbnail: a tight region of a large frame still stays small. */
const ROW_THUMB_FETCH_CAP = 512;

/**
 * A Tabel row's photo thumbnail (frontend-r22.11): the resource view
 * (`rowThumbView` — a part's own, a type's first part with one), cropped to
 * its region. No view, or one that fails to load, is the same quiet empty
 * box — never a ranked best frame standing in.
 */
export function RowThumb({ view }: { view: ResourceView | null }) {
  if (view === null) return <span className={`${styles.thumb} ${styles.thumbNone}`} aria-hidden="true" />;
  return (
    <ViewImage
      view={view}
      displaySize={ROW_THUMB_MAX_SIZE}
      maxFetch={ROW_THUMB_FETCH_CAP}
      className={styles.thumb}
      label={null}
      quietFallback
    />
  );
}
